export default __webpack_public_path__ + "static/media/1.c6feb7f2.png";